var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97651 3.19526C8.1031 3.32029 8.17421 3.48986 8.17421 3.66667V5.01156C8.77271 5 9.44411 5 10.1992 5H13.7992C14.5543 5 15.2257 5 15.8242 5.01156V3.66667C15.8242 3.48986 15.8953 3.32029 16.0219 3.19526C16.1485 3.07024 16.3202 3 16.4992 3C16.6782 3 16.8499 3.07024 16.9765 3.19526C17.1031 3.32029 17.1742 3.48986 17.1742 3.66667V5.07022C18.4693 5.17333 19.3198 5.424 19.9444 6.04178C20.5699 6.65867 20.8237 7.49778 20.9281 8.77778H3.07031C3.17471 7.49867 3.42851 6.65867 4.05401 6.04178C4.67861 5.424 5.52821 5.17333 6.82421 5.07111V3.66667C6.82421 3.48986 6.89533 3.32029 7.02192 3.19526C7.1485 3.07024 7.32019 3 7.49921 3C7.67823 3 7.84992 3.07024 7.97651 3.19526Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 13.8889V12.1111C21 11.3653 21 10.7022 20.9883 10.1111H3.0117C3 10.7022 3 11.3653 3 12.1111V13.8889C3 17.2409 3 18.9173 4.0548 19.9582C5.1087 21 6.8061 21 10.2 21H13.8C17.1939 21 18.8913 21 19.9452 19.9582C21 18.9173 21 17.2409 21 13.8889ZM17.0046 17.0539C16.7514 17.304 16.408 17.4445 16.05 17.4445C15.692 17.4445 15.3486 17.304 15.0954 17.0539C14.8422 16.8039 14.7 16.4647 14.7 16.1111C14.7 15.7575 14.8422 15.4184 15.0954 15.1683C15.3486 14.9183 15.692 14.7778 16.05 14.7778C16.408 14.7778 16.7514 14.9183 17.0046 15.1683C17.2578 15.4184 17.4 15.7575 17.4 16.1111C17.4 16.4647 17.2578 16.8039 17.0046 17.0539Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaricon);
export default __webpack_public_path__ + "static/media/calendar.icon.e5ea61c1acd8f3f4d46a2267b554e1f0.svg";
export { ForwardRef as ReactComponent };